import React, { useEffect, useMemo, useState } from 'react';
import {
    Button,
    FlexDirectionRow,
    FormContainer,
    MainContainer,
    MainContent,
    SubTitle,
    Title,
} from '../../../../../components/StyledComponents';
import { useFieldArray, useForm } from 'react-hook-form';
import Spinner from 'react-spinner-material';
import { useHistory, useParams } from 'react-router-dom';
import Input from '../../../../../components/InputControlled';
import { valueIsRequired } from '../../../../../utils/regex';
import { MdContentCopy } from 'react-icons/md';
import { SquareSearchInput } from '../../../../../components/SquareSearchInput';
import { ProjetoAcoesService } from '../../../services/projetoAcoesService';
import { ContentSpinner, PratifContainer } from './incluir-styled';
import ActionsGroup from '../../../../../components/ActionsGroup';
import { BaSeDialogContext, BaSeIcon } from '@base/react';
import SelectUfPratif from '../../../../../components/SelectUfPratif';
import { handleModalStatus } from '../../../../../utils/handleModalStatus';
import { UserActionsContent } from "../../../../../components/UserActionsContent";
import { Grid, Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import { ImCancelCircle } from "react-icons/im";
import styles from "../../RegrasContabilizacao/IncluirRegrasContabilizacao/styles.module.scss";
import { BsPlusCircle } from "react-icons/bs";
import { sortByDirection } from "../../../../../utils/utils";

export const EditarProjetoAcoes = () => {
    const history = useHistory();
    const {showModal} = React.useContext(BaSeDialogContext);
    const {id} = useParams();

    const [data, setData] = useState({
        nomePratif: '',
        regionais: [{
            descricao: '',
            uf: null,
            acao: null,
        }]
    });
    const [isLoading, setIsLoading] = useState(true);

    const {
        watch,
        control, handleSubmit, formState, reset
    } = useForm({
        defaultValues: useMemo(() => {
            return data;
        }, [data]),
    });

    const acoesSelecionadas = watch('acoes');
    const regionaisWatch = watch('regionais');
    console.log('regionaisWatch', regionaisWatch);

    const {isSubmitting} = formState;

    const {
        replace: replaceRegionais,
        fields: regionais,
        append: appendRegionais,
        remove: removeRegionais,

    } = useFieldArray({
        control,
        name: 'regionais',
        rules: {},
    });

    const findProjeto = (idProjeto) => {
        ProjetoAcoesService.findById(idProjeto).then((response) => {
            console.log('findProjeto')
            console.log('response', response)
            setData(response);
            setIsLoading(false);
        });
    };

    const findRegionais = async (data) => {
        console.log('findRegionais', data);
        const acao = data?.acoes?.filter(d => d.id)?.[0]
        console.log('acao', acao);
        if (!acao?.id) return;
        try {
            const response = await ProjetoAcoesService.findRegionaisById(acao?.id)
            console.log('response', response);
            replaceRegionais([]);
            if (!response.length) {
                replaceRegionais({
                    descricao: '',
                    uf: null,
                    acao: null,
                })
                return;
            }
            replaceRegionais(sortByDirection(response, 'id', 'ASC'));
        } catch (e) {
            console.log('erros regionais', e);
        }
    };

    useEffect(() => {
        setIsLoading(true);
        findProjeto(id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        console.log('data', data);
        reset(data);
        findRegionais(data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    const handleGoHome = () => {
        history.push('/tabelas-de-controle/ProjetosAcoes');

    };

    const submitForm = async (dataForm) => {
        try {
            const response = await ProjetoAcoesService.edit(dataForm);
            if (response && acoesSelecionadas?.length === 1) {
                const dataFormaRegionais = dataForm?.regionais?.map(f => ({
                    id: f?.id,
                    descricao: f?.descricao,
                    acao: dataForm.acoes[0],
                    uf: dataForm.uf
                }));
                const hasRegionalFilled = dataFormaRegionais.some(r => r.descricao);
                if (hasRegionalFilled) {
                    await ProjetoAcoesService.editRegionais(dataFormaRegionais);
                }
            }
            handleModalStatus({
                type: 'success',
                msgOnSuccess: 'Projeto e ações editados com sucesso.',
                onCloseModal: handleGoHome,
                showModal,
            });
        } catch (e) {
            handleModalStatus({
                type: 'error',
                showModal,
            });
        }
    };

    const handleRemoveRegional = (index) => {
        const regionais = watch('regionais');
        if (regionais?.length === 1) return;
        removeRegionais(index);
    }

    return (
        <>
            <MainContainer backgroundColor={'#0061C6'}>
                <FlexDirectionRow>
                    <FlexDirectionRow style={{width: '100%'}}>
                        <MdContentCopy size={40} color="#ffffff"/>
                        <Title>Tabelas de Controle</Title>
                    </FlexDirectionRow>
                    <BaSeIcon
                        onClick={handleGoHome}
                        name={'arrow-circle-left'}
                        description="voltar"
                        color="#ffffff"
                        size={50}
                    />
                </FlexDirectionRow>
            </MainContainer>
            <MainContent>
                <SubTitle>
                    <h3>Editar</h3>
                </SubTitle>
                <PratifContainer>
                    <SquareSearchInput disabled={true} value={data?.nuPratif}/>
                    {isLoading ? (
                        <ContentSpinner>
                            <Spinner
                                radius={20}
                                color={'#0061C6'}
                                stroke={2}
                                visible={true}
                            />
                            <p
                                style={{
                                    color: '#ccc',
                                    fontSize: '12px',
                                    marginLeft: '0.5rem',
                                }}
                            >
                                Buscando PRATIF...
                            </p>
                        </ContentSpinner>
                    ) : !!data ? (
                        <SelectUfPratif
                            name="uf"
                            defaultName={data?.uf?.sigla}
                            defaultValue={data?.uf?.id}
                            placeholder="UF"
                            control={control}
                            rules={{...valueIsRequired()}}
                        />
                    ) : (
                        ''
                    )}
                </PratifContainer>

                {isLoading ? (
                    <></>
                ) : (
                    <FormContainer>
                        <div style={{flex: 1}}>
                            {!!data ? (
                                <>
                                    <div style={{marginTop: '1rem'}}>
                                        <Input
                                            name="nomePratif"
                                            control={control}
                                            rules={{...valueIsRequired()}}
                                            placeholder="Nome do projeto"
                                            disabled={true}
                                            maxLength={140}
                                            background={'#f1f1f1'}
                                            cursor={'no-drop'}
                                        />

                                        <ActionsGroup
                                            actions={data?.acoes}
                                            nameAction="nomeAcao"
                                            descAction="descricao"
                                            id="id"
                                            name="acoes"
                                            control={control}
                                            rules={{...valueIsRequired()}}
                                            title="Ações"
                                            title2="Descrição no app"
                                        />
                                    </div>

                                    {
                                        (acoesSelecionadas?.length === 1) && (
                                            <Stack direction="column" spacing={2}>
                                                <Stack>
                                                    <Typography><b>Regionais</b></Typography>
                                                    <Typography mt={2} mb={2}><b>Descrição no app</b></Typography>
                                                </Stack>

                                                {regionais.map((item, index) => (
                                                    <Grid key={index} container item>
                                                        <Grid item md={6}>
                                                            <Input
                                                                style={{marginBlock: 0}}
                                                                label={null}
                                                                name={`regionais.${index}.descricao`}
                                                                type="text"
                                                                value={item.descricao}
                                                                control={control}
                                                            />
                                                        </Grid>
                                                        <Grid mx={2} item md={2} display={'flex'} flexDirection='columm' alignItems="center" gap=".3rem" style={{marginTop: '-10px'}}>
                                                            <Tooltip title="Delete">
                                                                <div>
                                                                    <ImCancelCircle
                                                                        size={20}
                                                                        color="#F4455A"
                                                                        onClick={() => handleRemoveRegional(index)}
                                                                    />
                                                                </div>
                                                            </Tooltip>
                                                            <Tooltip title="Adicionar">
                                                                <div>
                                                                    <button
                                                                        type="button"
                                                                        className={styles.actionsButtonAdd}
                                                                        style={{
                                                                            cursor: 'pointer',
                                                                            display: index === 0 ? '' : 'none',
                                                                        }}
                                                                        onClick={() => {
                                                                            appendRegionais({
                                                                                descricao: '',
                                                                                uf: null,
                                                                                acao: null,
                                                                            });
                                                                        }}
                                                                    >
                                                                        <BsPlusCircle size={20} color="#0061C6"/>
                                                                    </button>
                                                                </div>
                                                            </Tooltip>
                                                        </Grid>
                                                    </Grid>
                                                ))}
                                            </Stack>
                                        )
                                    }
                                </>
                            ) : (
                                ''
                            )}
                        </div>
                    </FormContainer>
                )
                }
                <div style={{flex: 1, marginBottom: '1rem'}}>
                    <FlexDirectionRow
                        position={'end'}
                        align={'end'}
                        style={{
                            marginRight: '40px',
                            width: '100%',
                            height: '100%',
                        }}
                    >
                        <Button
                            href="#"
                            onClick={handleSubmit(submitForm)}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? (
                                <Spinner radius={5} color={'#fff'} stroke={2} visible={true}/>
                            ) : (
                                'Editar projeto'
                            )}
                        </Button>
                    </FlexDirectionRow>
                </div>
            </MainContent>
            <UserActionsContent data={data}/>
        </>
    );
};
